import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b1ec9aa0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personal__name"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "personal__setting"
};
const _hoisted_4 = {
  class: "personal__setting"
};
const _hoisted_5 = {
  class: "personal__footer"
};
const _hoisted_6 = {
  class: "personal__footer-item"
};
const _hoisted_7 = {
  key: 0,
  class: "point"
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import SettingItem from '@remote/components/SettingItem.vue';
import DeviceIndicator from '@remote/components/DeviceIndicator.vue';
import SpeedSetting from '@remote/components/SpeedSetting.vue';
import DownloadTaskNum from '@remote/components/DownloadTaskNum.vue';
import { getLocalValue, setLocalValue } from '@remote/utils/index';
import { TdVipBadge } from '@xunlei/thunder-ui-vue3/dist/VipBadge';
import '@xunlei/thunder-ui-vue3/dist/VipBadge/styles/VipBadge.css';
import { onMounted } from 'vue';
import router from '@remote/router';
import { stat } from '@remote/utils/stat';
import { isAndroidNative, isIOSNative } from '@xunlei/universal-native-api';
import { useEnvStore } from '@remote/store/env';
import { useDeviceStore } from '@remote/store/device';
import { useUserStore } from '@remote/store/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const showPoint = ref(Boolean(isIOSNative && isAndroidNative && !getLocalValue('hideMorePoint')));
    // state
    const user = computed(() => {
      return store.state.user;
    });
    const action = computed(() => {
      return store.state.action;
    });
    const showSpeedControl = computed(() => {
      return store.state.showSpeedControl;
    });
    const deviceStore = useDeviceStore();
    const status = computed(() => {
      var _deviceStore$currentD;
      return ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    });
    const deviceInfoWatchData = computed(() => {
      return store.state.deviceInfoWatchData;
    });
    const isKuainiaoShow = computed(() => {
      var _deviceStore$currentD2;
      return (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.util.hasLabel('withKuainiaoNew');
    });
    const userStore = useUserStore();
    const vipRemains = computed(() => {
      var _userStore$platinumVi, _userStore$superVipDe;
      const platinumSurplus = Number((_userStore$platinumVi = userStore.platinumVipDetail) === null || _userStore$platinumVi === void 0 ? void 0 : _userStore$platinumVi.SurplusDay);
      const superSurplus = Number((_userStore$superVipDe = userStore.superVipDetail) === null || _userStore$superVipDe === void 0 ? void 0 : _userStore$superVipDe.SurplusDay);
      if (platinumSurplus > 0 && superSurplus > 0) {
        return `超级会员剩余${superSurplus}天, 白金会员剩余${platinumSurplus}天`;
      }
      if (superSurplus > 0) {
        return `您的会员时长剩余 ${superSurplus}天`;
      }
      if (platinumSurplus > 0) {
        return `您的会员时长剩余 ${platinumSurplus}天`;
      }
      return '您还不是会员 开通享下载加速特权';
    });
    // getters
    const showVip = computed(() => {
      return store.getters.showVip;
    });
    const isVip = computed(() => {
      return store.getters.isVip;
    });
    const isSuperVip = computed(() => {
      return store.getters.isSuperVip;
    });
    // computed
    const avatarURL = computed(() => {
      var _store$state$user, _userStore$user;
      return ((_store$state$user = store.state.user) === null || _store$state$user === void 0 ? void 0 : _store$state$user.avatarURL) || ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.picture) || 'https://xfile2.a.88cdn.com/file/k/avatar/default';
    });
    const nickName = computed(() => {
      var _user$value;
      return ((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.nickName) || '';
    });
    const clientVersion = computed(() => {
      var _deviceInfoWatchData$, _deviceInfoWatchData$2;
      return (_deviceInfoWatchData$ = (_deviceInfoWatchData$2 = deviceInfoWatchData.value) === null || _deviceInfoWatchData$2 === void 0 ? void 0 : _deviceInfoWatchData$2.client_version) !== null && _deviceInfoWatchData$ !== void 0 ? _deviceInfoWatchData$ : '';
    });
    const envStore = useEnvStore();
    const isRemoteDownloadGuideShow = computed(() => {
      // 厂商App和小程序不展示
      return !(store.state.isApp || store.state.isMiniProgram || envStore.isInPC);
    });
    watch(action, val => {
      if (val === 'tip-guide') {
        store.commit('dialog', {
          show: false
        });
        store.dispatch('close');
      }
    });
    // method
    const goVip = () => {
      stat({
        action: 'mytab_openvip_btn_click'
      });
      store.dispatch('goVip', {
        position: 'open'
      });
    };
    const handleShowMore = () => {
      if (showPoint.value) {
        setLocalValue('hideMorePoint', true);
        showPoint.value = false;
      }
      router.push({
        name: 'moreInfo',
        query: router.currentRoute.value.query
      });
    };
    onMounted(() => {
      document.title = '帐号信息';
      stat({
        action: 'mytab_page_show'
      });
    });
    return (_ctx, _cache) => {
      var _user$value2, _user$value3, _user$value4, _user$value5;
      const _directive_see = _resolveDirective("see");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["personal", {
          'is-vip': isVip.value
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["personal__body", {
          'is-vip': isVip.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: avatarURL.value,
        class: "avatar",
        alt: "头像",
        draggable: "false"
      }, null, 8, _hoisted_2), _createElementVNode("section", null, [_createElementVNode("p", null, _toDisplayString(nickName.value), 1), _createVNode(_unref(TdVipBadge), {
        "vip-level": (_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.vipLevel,
        "is-vip": (_user$value3 = user.value) === null || _user$value3 === void 0 ? void 0 : _user$value3.isVip,
        "is-year": (_user$value4 = user.value) === null || _user$value4 === void 0 ? void 0 : _user$value4.isYear,
        "vas-type": (_user$value5 = user.value) === null || _user$value5 === void 0 ? void 0 : _user$value5.vipType,
        size: "large"
      }, null, 8, ["vip-level", "is-vip", "is-year", "vas-type"])])]), _createElementVNode("p", {
        class: _normalizeClass(["personal__tip vip", {
          'is-vip': isVip.value
        }])
      }, [_createElementVNode("span", null, _toDisplayString(!isVip.value ? '您还不是会员 开通享下载加速特权' : vipRemains.value), 1), showVip.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "personal__tip-btn",
        onClick: goVip
      }, _toDisplayString(isVip.value ? isSuperVip.value ? '续费会员' : '升级超会' : '开通会员'), 1)) : _createCommentVNode("", true)], 2)], 2), isRemoteDownloadGuideShow.value || isKuainiaoShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [isRemoteDownloadGuideShow.value ? _withDirectives((_openBlock(), _createBlock(SettingItem, {
        key: 0,
        title: "远程遥控下载",
        "list-title": "设备管理",
        "click-id": "remote_download_guide"
      }, null, 512)), [[_directive_see, () => _unref(stat)({
        action: 'mytab_remote_download_item_show'
      }), void 0, {
        once: true
      }]]) : _createCommentVNode("", true), isKuainiaoShow.value ? (_openBlock(), _createBlock(SettingItem, {
        key: 1,
        title: "快鸟宽带提速",
        "list-title": "快鸟宽带提速",
        "click-id": "kuainiao"
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [!_unref(store).state.justOne ? (_openBlock(), _createBlock(SettingItem, {
        key: 0,
        title: "远程设备",
        "list-title": "设备管理",
        "click-id": "remote_device"
      }, {
        header: _withCtx(() => [_createVNode(DeviceIndicator)]),
        _: 1
      })) : _createCommentVNode("", true), showSpeedControl.value ? (_openBlock(), _createBlock(SettingItem, {
        key: 1,
        title: "下载速度设置",
        "list-title": "下载速度设置",
        "is-bottom": "",
        disabled: !status.value,
        "click-id": "set_downloadspeed"
      }, {
        content: _withCtx(() => [_createVNode(SpeedSetting)]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(SettingItem, {
        title: "同时下载任务数",
        "list-title": "同时下载任务数",
        disabled: !status.value,
        "click-id": "downloadtask_num"
      }, {
        content: _withCtx(props => [_createVNode(DownloadTaskNum, {
          close: props.close
        }, null, 8, ["close"])]),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(SettingItem, {
        "native-click": "",
        title: "更多",
        "click-id": "more",
        onClick: handleShowMore
      }, {
        extra: _withCtx(() => [showPoint.value && clientVersion.value.match(/2.13/) ? (_openBlock(), _createElementBlock("span", _hoisted_7)) : _createCommentVNode("", true)]),
        _: 1
      })])])], 2);
    };
  }
});